import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

// import utils
import { setBodyBackgroudColor } from 'js/utils/general';

// import hooks
import { useRouteInfo } from 'js/hooks/useRouteInfo';

// import containers
import SectionPageWrapper from 'js/containers/section/Section.page-wrapper';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import TransitionPage from 'js/containers/transition/Transition.page';
import { setScreenName } from '../utils/tracking';

// import selectors
import { getSiteMetaData } from 'js/store/app/App.selectors';

const BG_COLORS = {
  default: '#9DC145',
  results: '#F7EBB1',
};

const PageFind = ({ path }) => {
  const siteMetaData = useSelector((state) => getSiteMetaData(state, path));
  const [color, setColor] = useState(BG_COLORS.default);
  const { location } = useRouteInfo();

  React.useEffect(() => {
    setScreenName('Find');
  }, []);

  useEffect(() => {
    if (location.pathname.includes('results')) {
      setBodyBackgroudColor(BG_COLORS.results);
      setColor(BG_COLORS.results);
    } else {
      setBodyBackgroudColor(BG_COLORS.default);
      setColor(BG_COLORS.default);
    }
  }, [location]);

  return (
    <TransitionPage>
      <GenericMetadata
        title={siteMetaData.title}
        description={siteMetaData.description}
        keywords={siteMetaData.keywords}
      />
      <SectionPageWrapper className="page--find" bgColor={color}>
        <Outlet />
      </SectionPageWrapper>
    </TransitionPage>
  );
};

export default PageFind;
